import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout.js';
import { TemplateList } from './components/TemplateList.js';
import { TemplateDesigner } from './components/TemplateDesigner.js';
import { VersionHistory } from './components/VersionHistory.js';

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<TemplateList />} />
        <Route path="/templates/new" element={<TemplateDesigner />} />
        <Route path="/templates/:id/edit" element={<TemplateDesigner />} />
        <Route path="/templates/:id/versions" element={<VersionHistory />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
